import React, { useEffect, useState } from 'react'

import { CoverSpinning } from '../elements'

export interface InitLIFFScriptProps {
    liffId: string
    redirectUri?: string
    children?: React.ReactNode
}

const InitLIFFScript: React.FC<InitLIFFScriptProps> = ({ liffId, redirectUri, children }) => {
    const [initialize, setInitialize] = useState(false)

    useEffect(() => {
        async function init() {
            if (initialize) return
            await window.liff.init({ liffId })
            if (!window.liff.isLoggedIn()) {
                window.liff.login(redirectUri ? { redirectUri } : {})
            } else {
                window.sessionStorage.setItem('accessToken', window.liff.getAccessToken() || '')
            }
            setInitialize(true)
        }
        init()
    }, [initialize, liffId, redirectUri])

    return !initialize ? <CoverSpinning /> : <>{children}</>
}

export default InitLIFFScript
